import { FEATURE_FLAG_KEYS, REMOTE_CONFIG_KEYS, } from '@puzzlemania/remote-config';
import { applyXpGrant } from './xp-curve';
import { progressionStore } from './progression.store';
/**
 * `IAnalyticsProvider` decorator that grants XP (WP-XP.5) whenever a matching analytics
 * event fires — forwards every call to the wrapped inner provider unconditionally, same
 * shape as Module 21's `CrazyGamesAdBreakAnalyticsProvider`.
 *
 * Does NOT persist directly: `progressionStore`'s own subscription (wired in
 * composeServices.ts, WP-XP.2) already writes every state change through
 * `ProgressionSaveModule` — mirrors how `EconomyService.credit()` doesn't save directly
 * either, relying on `economyStore`'s own subscription.
 *
 * Gated by `FEATURE_FLAG_KEYS.XP_ENABLED` (WP-XP.6) — a disabled flag skips the grant
 * entirely (checked after forwarding, so analytics logging itself is never affected by
 * this flag).
 */
export class ProgressionAnalyticsProvider {
    constructor(_inner, _remoteConfig, _rules) {
        this._inner = _inner;
        this._remoteConfig = _remoteConfig;
        this._rules = _rules;
    }
    logEvent(name, params) {
        this._inner.logEvent(name, params);
        if (!this._remoteConfig.getBoolean(FEATURE_FLAG_KEYS.XP_ENABLED, true))
            return;
        const rule = this._rules.find((r) => r.eventName === name);
        if (!rule)
            return;
        const amount = rule.getXpAmount(params);
        if (amount === null || amount <= 0)
            return;
        const base = this._remoteConfig.getNumber(REMOTE_CONFIG_KEYS.XP_CURVE_BASE, 100);
        const increment = this._remoteConfig.getNumber(REMOTE_CONFIG_KEYS.XP_CURVE_INCREMENT, 50);
        const current = progressionStore.getState();
        const result = applyXpGrant(current, amount, base, increment);
        progressionStore.setState({
            xp: result.xp,
            level: result.level,
            lastLevelUp: result.levelsGained.length > 0
                ? result.levelsGained[result.levelsGained.length - 1]
                : current.lastLevelUp,
        });
    }
    setUserProperty(key, value) {
        this._inner.setUserProperty(key, value);
    }
}
